import { toast } from 'react-toastify';

// Helper function to show success toasts
export const showSuccessToast = (message, options = {}) => {
  // First dismiss any existing toasts
  toast.dismiss();
  
  // Create and return new toast with consistent styling
  return toast.success(message, {
    position: "top-center",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: 'profile-toast-success global-toast',
    style: { zIndex: 99999999 },
    containerId: 'global-toast-container',
    ...options
  });
};

// Helper function to show error toasts
export const showErrorToast = (message, options = {}) => {
  // First dismiss any existing toasts
  toast.dismiss();
  
  // Create and return new toast with consistent styling
  return toast.error(message, {
    position: "top-center", 
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: 'profile-toast-error global-toast',
    style: { zIndex: 99999999 },
    containerId: 'global-toast-container',
    ...options
  });
};

// Helper function to show warning toasts
export const showWarningToast = (message, options = {}) => {
  // First dismiss any existing toasts
  toast.dismiss();
  
  // Create and return new toast with consistent styling
  return toast.warning(message, {
    position: "top-center",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: 'profile-toast-warning global-toast',
    style: { zIndex: 99999999 },
    containerId: 'global-toast-container',
    ...options
  });
};

// Helper function to show info toasts
export const showInfoToast = (message, options = {}) => {
  // First dismiss any existing toasts
  toast.dismiss();
  
  // Create and return new toast with consistent styling
  return toast.info(message, {
    position: "top-center",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: 'profile-toast-info global-toast',
    style: { zIndex: 99999999 },
    containerId: 'global-toast-container',
    ...options
  });
};

// Helper function to dismiss all toasts
export const dismissAllToasts = () => {
  toast.dismiss();
}; 